import WisDetailsModalHeading from 'common/components/WISDetailsModal/Heading'

import type { IWisDetailsModalSectionProps } from './types'
import WisDetailsModalRow from './Row'

export const WisDetailsModalSection = ({
  items,
  title,
  isInAccordion
}: IWisDetailsModalSectionProps) => {
  return (
    <div>
      {title && (
        <WisDetailsModalHeading isInAccordion={isInAccordion}>
          {title}
        </WisDetailsModalHeading>
      )}
      <div className={`w-full ${isInAccordion ? 'px-3' : 'px-6'} mb-6`}>
        {items.map((item, index, array) => {
          const withBorder = array.length === 1 || index + 1 < array.length

          return (
            <div key={`${array.length}-${index}`}>
              <WisDetailsModalRow
                isInAccordion={isInAccordion}
                withBorder={withBorder}
                name={item.name}
                value={item.value}
              />
              {item.children}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default WisDetailsModalSection
